import { render, staticRenderFns } from "./SwitchSync.vue?vue&type=template&id=4cef0356&scoped=true&lang=pug"
import script from "./SwitchSync.vue?vue&type=script&lang=js"
export * from "./SwitchSync.vue?vue&type=script&lang=js"
import style0 from "./SwitchSync.vue?vue&type=style&index=0&id=4cef0356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef0356",
  null
  
)

export default component.exports